import { useEffect, useState } from 'react'
import { CalendarIcon } from '../icons'
import TypographyCaps from '../typography/TypographyCaps'
import clsx from 'clsx'
import TypographyParagraph from '../typography/TypographyParagraph'
import Callout from '../callout/callout'

const CalendarInput = ({
	name = 'Date',
	displayName = true,
	displayRequired = false,
	iconPlacement = 'left',
	isError = false,
	isInactive = false,
	containerWidth = 'w-80',
	value = '',
	onChange = () => {},
	minDate,
	maxDate,
	helper,
}: {
	name: string
	displayName?: boolean
	displayRequired?: boolean
	iconPlacement?: 'left' | 'right'
	isError?: boolean
	isInactive?: boolean
	containerWidth?: string
	value?: string
	onChange?: (e: any) => void
	minDate?: string
	maxDate?: string
	helper?: string
}) => {
	const [hasEnteredValue, setHasEnteredValue] = useState(false)

	useEffect(() => {
		if (value !== undefined && value !== '') {
			if (hasEnteredValue === false) {
				setHasEnteredValue(true)
			}
		}
	}, [hasEnteredValue, value])

	return (
		<div className={`${containerWidth}`}>
			{displayName && (
				<label
					htmlFor={name}
					className="mb-1 block leading-[14px] text-grey400 dark:text-grey500"
				>
					<TypographyCaps size="small">{`${name}${displayRequired ? ' *' : ''}`}</TypographyCaps>
				</label>
			)}
			<div
				className={clsx(
					'mt group relative rounded-md',
					// 'drop-shadow-menu dark:drop-shadow-none',
					// isError && 'ring-1 ring-red',
				)}
			>
				<div
					className={clsx(
						'flex w-full rounded-md border-0 px-4 py-3 font-abc text-paragraphMedium outline-0 ring-1 ring-inset',
						// DROP SHADOW
						// 'drop-shadow-menu dark:drop-shadow-none',
						// Default
						!isError &&
							'text-textPrimaryLight ring-textInactiveLight dark:text-textPrimaryDark dark:ring-textInactiveDark',
						// Inactive
						isInactive &&
							'cursor-not-allowed bg-uiSecondaryLight text-textPrimaryLight placeholder:text-textSecondaryLight dark:bg-black dark:text-textPrimaryDark dark:placeholder:text-textSecondaryDark',
						!isInactive &&
							'cursor-pointer bg-white text-grey400 placeholder:text-grey400 dark:bg-dark dark:text-grey600 dark:placeholder:text-grey600',
						// Validated
						!isInactive && !isError && 'ring-green',
						// hasError
						!isInactive && isError && 'ring-red',
						// Hover
						!isInactive &&
							'hover:ring-textSecondaryLight dark:hover:ring-textSecondaryDark',
						// Focus
						!isInactive &&
							'focus:text-textPrimaryLight focus:placeholder-textPrimaryLight focus:ring-textPrimaryLight dark:focus:text-textPrimaryDark dark:focus:placeholder-textPrimaryDark dark:focus:ring-textPrimaryDark',
					)}
				>
					{iconPlacement === 'left' ? (
						<div className="flex items-center pl-1 text-textSecondaryLight dark:text-textSecondaryDark">
							<CalendarIcon />
						</div>
					) : null}
					<input
						type="date"
						placeholder="DD-MM-YYYY"
						value={value}
						onChange={e => {
							if (e.target.value && hasEnteredValue === false) {
								setHasEnteredValue(true)
							} else if (!e.target.value && hasEnteredValue === true) {
								setHasEnteredValue(false)
							}
							onChange(e)
						}}
						name={name}
						id={name}
						disabled={isInactive}
						min={minDate}
						max={maxDate}
						className={clsx(
							'block flex-1 border-0 bg-transparent py-0 pl-0 focus:ring-0',
							//  sm:text-sm/6',
							hasEnteredValue
								? 'text-textPrimaryLight dark:text-textPrimaryDark'
								: 'text-grey400 dark:text-grey600',
							// 'text-textPrimaryLight placeholder:text-grey400 dark:text-textPrimaryDark dark:placeholder:text-grey600',
							'font:text-paragraphMedium font-abc text-paragraphMedium placeholder:font-abc',
							// 'cursor-pointer font-abc text-paragraphMedium placeholder:uppercase dark:text-textPrimaryDark',
							// isInactive &&
							// 'cursor-not-allowed bg-uiPrimaryLight text-textInactiveLight placeholder:text-textInactiveLight dark:bg-uiSecondaryDark dark:text-textInactiveDark dark:placeholder:text-textInactiveDark',
							// !isInactive &&
							// 'focus:bg-uiPrimaryDark focus:text-textPrimaryDark focus:dark:bg-uiPrimaryLight',
							// 'block flex-1 w-full rounded-md border-0 py-1.5 pl-10 outline-0 ring-0 focus:outline-0 focus:ring-0',
							// !isInactive &&
							// 'placeholder:text-textSecondaryDark group-hover:placeholder:text-textSecondaryLight dark:placeholder:text-textSecondaryDark dark:placeholder:text-textSecondaryLight ',
							// !isInactive &&
							// hasEnteredValue &&
							// 'bg-uiPrimaryDark text-textPrimaryDark dark:bg-uiPrimaryLight dark:text-textPrimaryLight',
							// !isInactive &&
							// !hasEnteredValue &&
							// 'bg-uiPrimaryLight dark:bg-uiSecondaryDark',
						)}
					/>
					{iconPlacement === 'right' ? (
						<div className="flex items-center pl-1 text-textSecondaryLight dark:text-textSecondaryDark">
							<CalendarIcon />
						</div>
					) : null}
				</div>
			</div>
			{helper && isError ? (
				<Callout additionalClasses="mt-4" variant="error" content={helper} />
			) : helper ? (
				<TypographyParagraph
					size="xSmall"
					additionalClasses={clsx(
						'mt-2',
						isError
							? 'text-red dark:text-red'
							: 'text-textSecondaryLight dark:text-textSecondaryDark',
					)}
				>
					{helper}
				</TypographyParagraph>
			) : null}
		</div>
	)
}

export default CalendarInput
